import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

export const getSubscription = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}`, { headers });
};

export const createSubscription = async (name, apiKey) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}`, { headers, body: { name, apiKey } });
};

export const updateSubscription = async (updates) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}`, { headers, body: updates });
};

export const deleteSubscription = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}`, { headers });
};

export const getSyncSchedule = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/sync-schedule`, { headers });
};

export const getSubscriptionSummary = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/summary`, { headers });
};

export const rotateWebhookSecret = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/webhook-secret-rotation`, { headers });
};

export const getOAuthAuthorizeUrl = () => {
  const uuid = customerUuid();
  // The backend endpoint generates PKCE state and redirects to Klaviyo
  // Use the same API base that other service calls use (from App.js override)
  return API.endpoint("blustreamREST").then(base =>
    `${base}/gandalfproxy/api/integrations/klaviyo/oauth/authorize?customerUuid=${uuid}`
  );
};
